export default __webpack_public_path__ + "static/media/sysfar-logo.417f8ac3.png";